<template>
  <el-container id="lad-ask-question" class="is-vertical">
    <LadAskQuestionHeader :success="success" />

    <el-main>
      <LadAskQuestionContent
        :code="code"
        :success="success"
        :handle-success="handleSuccess"
      />
    </el-main>

    <el-dialog
      :visible.sync="isAskQuestionModalOpen"
      :before-close="handleClose"
      class="dialog--ask-question"
    >
      <template slot="title">
        <LadAskQuestionHeader :success="success" />
      </template>

      <LadAskQuestionContent
        :code="code"
        :success="success"
        :handle-success="handleSuccess"
      />
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadAskQuestionModal',
  components: {
    LadAskQuestionHeader: () =>
      import(/* webpackChunkName: "lad-ava-header" */ './components/header'),
    LadAskQuestionContent: () =>
      import(/* webpackChunkName: "lad-ava-content" */ './index'),
  },
  data() {
    return { success: false, code: null }
  },
  computed: {
    ...mapState('modals', {
      isAskQuestionModalOpen: (state) => state.askQuestion.opened,
    }),
  },
  beforeDestroy() {
    if (this.isAskQuestionModalOpen) {
      this.handleClose()
    }
  },
  methods: {
    async handleClose() {
      await this.$store.dispatch('modals/toggle', 'askQuestion')
    },
    handleSuccess(code) {
      this.code = code
      this.success = true
    },
  },
}
</script>

<style lang="scss">
#lad-ask-question {
  .el-main {
    margin: 0;

    @media (min-width: 768px) {
      margin: 0 auto;
    }
  }
}

.dialog--ask-question {
  .el-dialog {
    &__body {
      padding: 40px;

      .el-form {
        max-width: 550px;
        margin: 0 auto;
      }
    }
  }
}
</style>
